/**
 * Password validation rules for registration form.
 * These rules match AWS Cognito password policy.
 *
 * Requirements:
 * - Minimum 8 characters
 * - At least 1 lowercase letter
 * - At least 1 uppercase letter
 * - At least 1 number
 * - At least 1 special character
 *
 * Allowed special characters (per Cognito):
 * ^ $ * . [ ] { } ( ) ? - " ! @ # % & / \ , > < ' : ; | _ ~ ` + =
 * Plus non-leading, non-trailing spaces
 */

// Cognito special characters regex
const SPECIAL_CHARS_REGEX = /[\^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`+=\x20]/;

// Individual validation functions for testing
export const passwordValidators = {
	minLength: v => v.length >= 8 || 'Password must be at least 8 characters',
	hasLowercase: v => /[a-z]/.test(v) || 'Password must contain a lowercase letter',
	hasUppercase: v => /[A-Z]/.test(v) || 'Password must contain an uppercase letter',
	hasNumber: v => /\d/.test(v) || 'Password must contain a number',
	hasSpecialChar: v => SPECIAL_CHARS_REGEX.test(v) || 'Password must contain a special character',
	noLeadingTrailingSpace: v => v === v.trim() || 'Password cannot start or end with a space',
};

export const passwordRules = {
	required: 'Password is required',
	validate: passwordValidators,
};

export const confirmPasswordRules = getValues => ({
	required: 'Please confirm your password',
	validate: value => value === getValues('password') || 'Passwords do not match',
});
